import CurrentUserApiUtils from '../utils/api/currentUser';
import { addMessage as addModalMessage, hide as hideModal } from './modal';
import { logout } from './auth';
import { addMessage as addFlashMessage } from './flash';

export const FETCH_CURRENT_USER_SENT = 'FETCH_CURRENT_USER_SENT';
export const FETCH_CURRENT_USER_SUCCEEDED = 'FETCH_CURRENT_USER_SUCCEEDED';
export const FETCH_CURRENT_USER_FAILED = 'FETCH_CURRENT_USER_FAILED';
export const UPDATE_STUDENT_PROFILE_SENT = 'UPDATE_STUDENT_PROFILE_SENT';
export const UPDATE_STUDENT_PROFILE_SUCCEEDED =
  'UPDATE_STUDENT_PROFILE_SUCCEEDED';
export const UPDATE_STUDENT_PROFILE_FAILED = 'UPDATE_STUDENT_PROFILE_FAILED';
export const UPDATE_TUTOR_PROFILE_SENT = 'UPDATE_TUTOR_PROFILE_SENT';
export const UPDATE_TUTOR_PROFILE_SUCCEEDED = 'UPDATE_TUTOR_PROFILE_SUCCEEDED';
export const UPDATE_TUTOR_PROFILE_FAILED = 'UPDATE_TUTOR_PROFILE_FAILED';
export const UPLOAD_AVATAR_SENT = 'UPLOAD_AVATAR_SENT';
export const UPLOAD_AVATAR_SUCCEEDED = 'UPLOAD_AVATAR_SUCCEEDED';
export const UPLOAD_AVATAR_FAILED = 'UPLOAD_AVATAR_FAILED';
export const DELETE_AVATAR_SENT = 'DELETE_AVATAR_SENT';
export const DELETE_AVATAR_SUCCEEDED = 'DELETE_AVATAR_SUCCEEDED';
export const DELETE_AVATAR_FAILED = 'DELETE_AVATAR_FAILED';
export const FETCH_MY_AVATAR_SENT = 'FETCH_MY_AVATAR_SENT';
export const FETCH_MY_AVATAR_SUCCEEDED = 'FETCH_MY_AVATAR_SUCCEEDED';
export const FETCH_MY_AVATAR_FAILED = 'FETCH_MY_AVATAR_FAILED';
export const UPDATE_IP_SENT = 'UPDATE_IP_SENT';
export const UPDATE_IP_SUCCEEDED = 'UPDATE_IP_SUCCEEDED';
export const UPDATE_IP_FAILED = 'UPDATE_IP_FAILED';
export const SET_SKYPE_ID_SENT = 'SET_SKYPE_ID_SENT';
export const SET_SKYPE_ID_SUCCEEDED = 'SET_SKYPE_ID_SUCCEEDED';
export const SET_SKYPE_ID_FAILED = 'SET_SKYPE_ID_FAILED';
export const SET_TEAMS_CONTACT_EMAIL_SENT = 'SET_TEAMS_CONTACT_EMAIL_SENT';
export const SET_TEAMS_CONTACT_EMAIL_SUCCEEDED =
  'SET_TEAMS_CONTACT_EMAIL_SUCCEEDED';
export const SET_TEAMS_CONTACT_EMAIL_FAILED = 'SET_TEAMS_CONTACT_EMAIL_FAILED';
export const RESET_UNSEEN_MESSAGE_COUNT_SENT =
  'RESET_UNSEEN_MESSAGE_COUNT_SENT';
export const RESET_UNSEEN_MESSAGE_COUNT_SUCCEEDED =
  'RESET_UNSEEN_MESSAGE_COUNT_SUCCEEDED';
export const RESET_UNSEEN_MESSAGE_COUNT_FAILED =
  'RESET_UNSEEN_MESSAGE_COUNT_FAILED';
export const GET_UNSEEN_MESSAGE_COUNT_SENT = 'GET_UNSEEN_MESSAGE_COUNT_SENT';
export const GET_UNSEEN_MESSAGE_COUNT_SUCCEEDED =
  'GET_UNSEEN_MESSAGE_COUNT_SUCCEEDED';
export const GET_UNSEEN_MESSAGE_COUNT_FAILED =
  'GET_UNSEEN_MESSAGE_COUNT_FAILED';
export const FETCH_DATA_FOR_STUDENT_DASHBOARD_SENT =
  'FETCH_DATA_FOR_STUDENT_DASHBOARD_SENT';
export const FETCH_DATA_FOR_STUDENT_DASHBOARD_SUCCEEDED =
  'FETCH_DATA_FOR_STUDENT_DASHBOARD_SUCCEEDED';
export const FETCH_DATA_FOR_STUDENT_DASHBOARD_FAILED =
  'FETCH_DATA_FOR_STUDENT_DASHBOARD_FAILED';
export const FETCH_DATA_FOR_TUTOR_DASHBOARD_SENT =
  'FETCH_DATA_FOR_TUTOR_DASHBOARD_SENT';
export const FETCH_DATA_FOR_TUTOR_DASHBOARD_SUCCEEDED =
  'FETCH_DATA_FOR_TUTOR_DASHBOARD_SUCCEEDED';
export const FETCH_DATA_FOR_TUTOR_DASHBOARD_FAILED =
  'FETCH_DATA_FOR_TUTOR_DASHBOARD_FAILED';
export const GET_DATA_FOR_EDIT_TUTOR_PROFILE_SENT =
  'GET_DATA_FOR_EDIT_TUTOR_PROFILE_SENT';
export const GET_DATA_FOR_EDIT_TUTOR_PROFILE_SUCCEEDED =
  'GET_DATA_FOR_EDIT_TUTOR_PROFILE_SUCCEEDED';
export const GET_DATA_FOR_EDIT_TUTOR_PROFILE_FAILED =
  'GET_DATA_FOR_EDIT_TUTOR_PROFILE_FAILED';
export const DEACTIVATE_USER_SENT = 'DEACTIVATE_USER_SENT';
export const DEACTIVATE_USER_SUCCEEDED = 'DEACTIVATE_USER_SUCCEEDED';
export const DEACTIVATE_USER_FAILED = 'DEACTIVATE_USER_FAILED';
export const SET_SKYPE_MODAL_SHOWN = 'SET_SKYPE_MODAL_SHOWN';
export const SET_TEAMS_MODAL_SHOWN = 'SET_TEAMS_MODAL_SHOWN';

function addToLocalStorage(data) {
  localStorage.setItem('authToken', data.authToken);
  localStorage.setItem('profile', data.profile);
  localStorage.setItem('user', JSON.stringify(data.user));
}

function clearLocalStorage() {
  localStorage.removeItem('authToken');
  localStorage.removeItem('profile');
  localStorage.removeItem('user');
}

function dealWithLangChange(data) {
  const localeInfo = data.locale_info;
  if (localeInfo) {
    try {
      document.body.lang = localeInfo.locale.split('-')[0];
    } catch (err) {
      console.log('Attempted to assign to readonly property.');
    }
  }
}

export function setSkypeModalShown() {
  return { type: SET_SKYPE_MODAL_SHOWN };
}

export function setTeamsModalShown() {
  return { type: SET_TEAMS_MODAL_SHOWN };
}

export function fetchCurrentUserSent() {
  return {
    type: FETCH_CURRENT_USER_SENT,
  };
}

export function fetchCurrentUserSucceeded(data) {
  return {
    type: FETCH_CURRENT_USER_SUCCEEDED,
    payload: data,
  };
}

export function fetchCurrentUserFailed(error) {
  return {
    type: FETCH_CURRENT_USER_FAILED,
  };
}

export function fetchCurrentUser() {
  return (dispatch) => {
    dispatch(fetchCurrentUserSent());
    return CurrentUserApiUtils.me().then(
      (data) => {
        addToLocalStorage(data);
        dealWithLangChange(data);
        dispatch(fetchCurrentUserSucceeded(data));
      },
      (error) => {
        // Clear stale auth data from localStorage to prevent retry loops.
        // If the token can't authenticate, keeping it causes an infinite
        // cycle: detect token → fetch user → fail → redirect → repeat.
        clearLocalStorage();
        dispatch(fetchCurrentUserFailed(error));
      },
    );
  };
}

export function updateStudentProfileSent() {
  return {
    type: UPDATE_STUDENT_PROFILE_SENT,
  };
}

export function updateStudentProfileSucceeded(data) {
  addToLocalStorage(data);
  dealWithLangChange(data);
  return {
    type: UPDATE_STUDENT_PROFILE_SUCCEEDED,
    payload: data,
  };
}

export function updateStudentProfileFailed(error) {
  return {
    type: UPDATE_STUDENT_PROFILE_FAILED,
  };
}

export function updateStudentProfile(params) {
  return (dispatch) => {
    dispatch(updateStudentProfileSent());
    return CurrentUserApiUtils.updateStudentProfile(params).then(
      (data) => {
        dispatch(updateStudentProfileSucceeded(data));
        const opts = {
          type: 'success',
          autoDisappear: true,
          sticky: true,
        };
        dispatch(addFlashMessage(data.message, opts));
      },
      (error) => {
        dispatch(updateStudentProfileFailed(error));
        const opts = {
          type: 'error',
          autoDisappear: false,
          sticky: true,
        };
        dispatch(addFlashMessage(error.message, opts));
      },
    );
  };
}

export function updateTutorProfileSent() {
  return {
    type: UPDATE_TUTOR_PROFILE_SENT,
  };
}

export function updateTutorProfileSucceeded(data) {
  addToLocalStorage(data);
  return {
    type: UPDATE_TUTOR_PROFILE_SUCCEEDED,
    payload: data,
  };
}

export function updateTutorProfileFailed(error) {
  return {
    type: UPDATE_TUTOR_PROFILE_FAILED,
  };
}

export function updateTutorProfile(params) {
  return (dispatch) => {
    dispatch(updateTutorProfileSent());
    return CurrentUserApiUtils.updateTutorProfile(params).then(
      (data) => {
        dispatch(updateTutorProfileSucceeded(data));
        const opts = {
          type: 'success',
          autoDisappear: true,
          sticky: true,
        };
        dispatch(addFlashMessage(data.message, opts));
      },
      (error) => {
        dispatch(updateTutorProfileFailed(error));
        const opts = {
          type: 'error',
          autoDisappear: false,
          sticky: true,
        };
        dispatch(addFlashMessage(error.message, opts));
      },
    );
  };
}

export function uploadAvatarSent() {
  return {
    type: UPLOAD_AVATAR_SENT,
  };
}

export function uploadAvatarSucceeded(data) {
  addToLocalStorage(data);
  return {
    type: UPLOAD_AVATAR_SUCCEEDED,
    payload: data,
  };
}

export function uploadAvatarFailed(error) {
  return {
    type: UPLOAD_AVATAR_FAILED,
  };
}

export function uploadAvatar(file) {
  return (dispatch) => {
    dispatch(uploadAvatarSent());
    return CurrentUserApiUtils.uploadProfilePhoto(file).then(
      (data) => {
        dispatch(uploadAvatarSucceeded(data));
      },
      (error) => {
        dispatch(uploadAvatarFailed(error));
        const opts = {
          type: 'error',
          autoDisappear: true,
          sticky: true,
        };
        dispatch(addFlashMessage(error.message, opts));
      },
    );
  };
}

export function deleteAvatarSent() {
  return {
    type: DELETE_AVATAR_SENT,
  };
}

export function deleteAvatarSucceeded(data) {
  addToLocalStorage(data);
  return {
    type: DELETE_AVATAR_SUCCEEDED,
    payload: data,
  };
}

export function deleteAvatarFailed(error) {
  return {
    type: DELETE_AVATAR_FAILED,
  };
}

export function deleteAvatar() {
  return (dispatch) => {
    dispatch(deleteAvatarSent());
    return CurrentUserApiUtils.deleteProfilePhoto().then(
      (data) => {
        dispatch(deleteAvatarSucceeded(data));
      },
      (error) => {
        dispatch(deleteAvatarFailed(error));
        const opts = {
          type: 'error',
          autoDisappear: true,
          sticky: true,
        };
        dispatch(addFlashMessage(error.message, opts));
      },
    );
  };
}

export function deactivateSent() {
  return {
    type: DEACTIVATE_USER_SENT,
  };
}

export function deactivateSucceeded(data) {
  clearLocalStorage();
  return { type: DEACTIVATE_USER_SUCCEEDED };
}

export function deactivateFailed(error) {
  return {
    type: DEACTIVATE_USER_FAILED,
  };
}

export function deactivate(userId, reasonCode, comment) {
  return (dispatch) => {
    dispatch(deactivateSent());
    return CurrentUserApiUtils.deactivate(userId, reasonCode, comment).then(
      (data) => {
        dispatch(hideModal());
        dispatch(logout());
        const opts = {
          type: 'success',
          autoDisappear: false,
          sticky: true,
        };
        dispatch(addFlashMessage(data.message, opts));
      },
      (error) => {
        dispatch(deactivateFailed(error));
        const opts = {
          type: 'error',
          autoDisappear: true,
          sticky: true,
        };
        dispatch(addFlashMessage(error.message, opts));
      },
    );
  };
}

export function setSkypeIdSent() {
  return {
    type: SET_SKYPE_ID_SENT,
  };
}

export function setSkypeIdSucceeded(data) {
  addToLocalStorage(data);
  return {
    type: SET_SKYPE_ID_SUCCEEDED,
    payload: data,
  };
}

export function setSkypeIdFailed(error) {
  return {
    type: SET_SKYPE_ID_FAILED,
  };
}

export function setSkypeId(skypeId) {
  return (dispatch) => {
    dispatch(setSkypeIdSent());
    return CurrentUserApiUtils.setSkypeId(skypeId).then(
      (data) => {
        dispatch(hideModal());
        dispatch(setSkypeIdSucceeded(data));
        const opts = {
          type: 'success',
          autoDisappear: true,
          sticky: true,
        };
        dispatch(addFlashMessage(data.message, opts));
      },
      (error) => {
        dispatch(setSkypeIdFailed(error));
        const opts = {
          type: 'error',
          autoDisappear: false,
        };
        dispatch(addModalMessage(error.message, opts));
      },
    );
  };
}

export function setTeamsContactEmailSent() {
  return {
    type: SET_TEAMS_CONTACT_EMAIL_SENT,
  };
}

export function setTeamsContactEmailSucceeded(data) {
  addToLocalStorage(data);
  return {
    type: SET_TEAMS_CONTACT_EMAIL_SUCCEEDED,
    payload: data,
  };
}

export function setTeamsContactEmailFailed(error) {
  return {
    type: SET_TEAMS_CONTACT_EMAIL_FAILED,
  };
}

export function setTeamsContactEmail(teamsContactEmail) {
  return (dispatch) => {
    dispatch(setTeamsContactEmailSent());
    return CurrentUserApiUtils.setTeamsContactEmail(teamsContactEmail).then(
      (data) => {
        dispatch(hideModal());
        dispatch(setTeamsContactEmailSucceeded(data));
        const opts = {
          type: 'success',
          autoDisappear: true,
          sticky: true,
        };
        dispatch(addFlashMessage(data.message, opts));
      },
      (error) => {
        dispatch(setTeamsContactEmailFailed(error));
        const opts = {
          type: 'error',
          autoDisappear: false,
        };
        dispatch(addModalMessage(error.message, opts));
      },
    );
  };
}

export function getUnseenMessageCountSent() {
  return {
    type: GET_UNSEEN_MESSAGE_COUNT_SENT,
  };
}

export function getUnseenMessageCountSucceeded(data) {
  return {
    type: GET_UNSEEN_MESSAGE_COUNT_SUCCEEDED,
    payload: data,
  };
}

export function getUnseenMessageCountFailed(error) {
  return {
    type: GET_UNSEEN_MESSAGE_COUNT_FAILED,
  };
}

export function getUnseenMessageCount() {
  return (dispatch) => {
    dispatch(getUnseenMessageCountSent());
    return CurrentUserApiUtils.getUnseenMessageCount().then(
      (data) => {
        dispatch(getUnseenMessageCountSucceeded(data));
      },
      (error) => {
        dispatch(getUnseenMessageCountFailed(error));
      },
    );
  };
}

export function resetUnseenMessageCountToZeroSent() {
  return {
    type: RESET_UNSEEN_MESSAGE_COUNT_SENT,
  };
}

export function resetUnseenMessageCountToZeroSucceeded(data) {
  return {
    type: RESET_UNSEEN_MESSAGE_COUNT_SUCCEEDED,
    payload: data,
  };
}

export function resetUnseenMessageCountToZero() {
  return (dispatch) => {
    dispatch(resetUnseenMessageCountToZeroSent());
    return CurrentUserApiUtils.setUnseenMessageCountToZero().then((data) => {
      dispatch(resetUnseenMessageCountToZeroSucceeded(data));
    });
  };
}
